import Vue from 'vue';
/**
 * @Author     huzhiming
 * @createTime 2018-11-14
 * @desc       错误日志记录
 * @param      {String}   errorType   [错误类型]
 * @param      {[Object]}   content [附加信息]
 * @param      {[String]}   msg   [错误信息]
 * @param      {[String]}   level   [错误分类： 默认：'error','info','warn','debug']
 */
function log(errorType, content, level = 'error') {
    if (window.Owl) {
        try {
            if (JSON.stringify(content).length > 1024 * 5) {
                content = { url: content.url };
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
        const msid = Vue.prototype.$tools.cookie.get('msid');
        /**
         * addError(error,opts)
         * error:{
         *     name:"错误类型、名称"
         *     msg:"错误内容"
         * }
         * opts: 可选配置
         *         combo<Boolean>: 值为false时立刻上报错误，否则读取config中的error对象中的combo配置
         *         level: 错误级别，默认error，可参考下面的[错误类型和分类]
         *         category: 错误分类，默认jsError，可参考下面的错误类型和分类
         *         tags<Object>: 其他错误信息
         *
         * 参考地址：http://docs.sankuai.com/doc/f2e_dp/owl/deep/#adderrorerror-opts
         * @type {[type]}
         */
        window.Owl.addError(
            {
                name: errorType,
                msg: {
                    content,
                    msid,
                    time: Vue.prototype.$tools.formatTime(
                        new Date(),
                        'yyyy-MM-dd HH:mm:ss',
                    ),
                },
            },
            {
                level,
                tags: { msid },
            },
        );
    }
}
/**
 * @desc       主动上报的日志，便于敏感功能监控
 * @param      {[Object]}   content [请求参数和url]
 * @return     {[type]}           [description]
 */
export default function sendUserLog(logkey, content, level = 'info') {
    log(logkey, content, level);
}
